import React from "react";
import { formatNumberWithCommas } from "../../../../util/formatNumber";
import {
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Label,
  ComposedChart,
  ResponsiveContainer,
} from "recharts";
import GenderAgeCustomTooltip from "./genderAgeCustomTooltip";

const GenderAgeChart = ({ dataList }) => {
  return (
    <div
      style={{
        width: "100%",
        height: "fit-content",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        margin: "81px 0px 48px 0px",
      }}
    >
      <ResponsiveContainer width={934} height={229}>
        <ComposedChart
          data={dataList}
          margin={{ top: 0, right: 20, left: 30, bottom: 10 }}
        >
          <CartesianGrid stroke="rgba(255, 255, 255, 0.12)" vertical={false} />
          <XAxis
            dataKey={"ageGroup"}
            axisLine={false}
            stroke="rgba(255, 255, 255, 0.12)"
            interval={0}
            tickMargin={22}
            tickFormatter={(value) => value.replace("세", "")}
            tickSize={0} // 눈금 제거
            tick={{
              fontFamily: "Pretendard",
              fontWeight: 400,
              fontSize: 13,
              lineHeight: "20.25px",
              fill: "#aaa",
              textAnchor: "middle",
            }}
          >
            <Label
              value="(세)"
              position="insideRight" // "insideBottomRight", "insideBottom", "insideBottomLeft", "insideTopRight", "insideTop", "insideTopLeft"
              dx={20}
              dy={10}
              style={{
                fontFamily: "Pretendard",
                fontWeight: 500,
                fontSize: 13,
                lineHeight: "18.75px",
                fill: "rgba(181, 181, 181, 0.5)",
              }}
            />
          </XAxis>

          <YAxis
            yAxisId="left"
            orientation="left"
            axisLine={false}
            stroke="rgba(255, 255, 255, 0.12)"
            width={53}
            tickFormatter={(value) => formatNumberWithCommas(value)}
            tickSize={0} // 눈금 제거
            tickMargin={42} // 숫자와 축 사이의 간격 조정
            tick={{
              fontFamily: "Pretendard",
              fontWeight: 500,
              fontSize: 13,
              lineHeight: "18.75px",
              fill: "rgba(181, 181, 181, 0.5)",
              textAnchor: "end",
            }}
          >
            <Label
              value="(명)"
              position="insideBottom" // "insideBottomRight", "insideBottom", "insideBottomLeft", "insideTopRight", "insideTop", "insideTopLeft"
              offset={-30}
              dx={-25}
              style={{
                fontFamily: "Pretendard",
                fontWeight: 500,
                fontSize: 13,
                lineHeight: "18.75px",
                fill: "rgba(181, 181, 181, 0.5)",
              }}
            />
          </YAxis>
          <Tooltip cursor={false} content={<GenderAgeCustomTooltip />} />
          <Bar
            yAxisId="left"
            dataKey="male"
            fill="#009bde"
            radius={[2, 2, 0, 0]}
            barSize={14}
          />
          <Bar
            yAxisId="left"
            dataKey="female"
            fill="#cf6679"
            radius={[2, 2, 0, 0]}
            barSize={14}
          />
        </ComposedChart>
      </ResponsiveContainer>
    </div>
  );
};

export default GenderAgeChart;
